import { Router, ActivatedRoute } from "@angular/router";
import { elementAt, first } from "rxjs/operators";

import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { CoreConfigService } from "../../../../../@core/services/config.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";

import Stepper from "bs-stepper";
import { GoogleService } from "../../../../../services/google.service";
import Swal from "sweetalert2";

import { HttpClient } from "@angular/common/http";
import { catchError, tap } from "rxjs/operators";


import { EcommerceService } from "../../../apps/ecommerce/ecommerce.service";
import { ProductService } from "../../../../../services/product.service";
import { CustomerService } from "../../../../../services/customer.service";

import {
  NgbDateStruct,
  NgbCalendar,
  NgbDate,
  NgbDateParserFormatter,
  NgbTimeStruct,
} from "@ng-bootstrap/ng-bootstrap";

import { CommunicationService } from "../../../../../services/communication.service";

@Component({
  selector: "app-auth-register-invite",
  templateUrl: "./auth-register-invite.component.html",
  styleUrls: ["./auth-register-invite.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AuthRegisterInviteComponent implements OnInit {
  // Public OLD
  public coreConfig: any;
  public couponFieldValid = false;
  public passwordTextType: boolean;
  public registerForm: UntypedFormGroup;
  public submitted = false;
  public termCheck = false;
  public currentTermIdx = 0;
  public currentTerm = {
    title: "",
    content: "",
  };


  public token: string;
  public iframe = false;
  public info;
  public loading;
  public loadingButton = false;
  public members: any = {
    plans: [],
    max: [],
    credits: 10,
    totalMax: 10,
    price: { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 },
  };
  public today = new Date();
  public pageAdvanced = 1;
  public totalMembers = 0;
  public MinMaxDPdata: NgbDateStruct;

  public dataForm: any = [];
  public dataPlanOrder: any = [];
  public formattedAddress: any = [];
  public registerFormValidation: any = [];
  public allFormIsValid: boolean = false;

  // Private OLD
  private _unsubscribeAll: Subject<any>;

  // Public
  public contentHeader: object;
  public products;
  public locations;
  public selectLocation;
  public paymentPer;
  public cartList: any = [];
  public dependentCartList: any = [];
  public discountList: any = [];
  public totalPrice;
  public totalDiscount;
  public priceCounter;

  public validAccountHolder = false;

  public order: any = [];

  public wishlist;

  public items = [{ itemId: "", itemName: "", itemQuantity: "", itemCost: "" }];

  public item = {
    itemName: "",
    itemQuantity: "",
    itemCost: "",
  };

  public startAtDate = this.today;

  // Private
  private checkoutStepper: Stepper;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   * @param {FormBuilder} _formBuilder
   * @param {CommunicationService} _communicationService
   * @param {EcommerceService} _ecommerceService
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    private _route: ActivatedRoute,
    private _googleService: GoogleService,
    private _formBuilder: UntypedFormBuilder,
    private modalService: NgbModal,
    private http : HttpClient,
    private _communicationService: CommunicationService
  ) {
    this.totalPrice = { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 };
    this.totalDiscount = { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 };
    
    this.priceCounter = {
      setupFee: {
        holder: 0,
        dependents: 0,
        holderDiscount: 0,
        dependentsDiscount: 0,
        discount: 0,
        smilepass: 0,
        total:0
      },
      membershipFee: {
        holder: { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 },
        holderDiscount: { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 },
        dependents: { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 },
        dependentsDiscount: { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 },
        discount: { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 },
        smilepass: { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 },
        total: { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 }
      }
    };

    this.dataForm = [
      {
        firstName: "",
        lastName: "",
        email: "",
        countryAreaCode: 61,
        phoneNumber: "",
        gender: "",
        DoB: this.today,
        address: "",
        plan_id: "",
        documentNumber: ""
      },
    ];

    this.discountList = [
      {
        object: "coupon",
        name: "Dep. Discount",
        valid: false,
        setup_amount: 0,
        setup_percentage: 0,
        membership_amount: 0,
        membership_percentage: 0,
        planList: []
    }
    ];

    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.registerForm.controls;
  }

  /**
   * DeleteItem
   *
   * @param id
   */
  deleteItem(id) {
    for (let i = 0; i < this.dataForm.length; i++) {
      if (this.dataForm.indexOf(this.dataForm[i]) === id) {
        this.dataForm.splice(i, 1);
        break;
      }
    }
    this.info.planDetails = this.dataForm;
    this.updateForm();

  }

  checkCoupon(){
    var code = <HTMLInputElement>(
      document.getElementById("couponCode")
    );

    if(code.value.length > 0 ){
      this.loadingButton = true;            
      this._communicationService
      .checkCoupon(code.value, this.token)    
      .pipe(first())
      .subscribe(
        
        data => {           
          if(data["valid"] == true){
            this.discountList[1] = data;
          }else{
            this.discountList.splice(1, 1);
          }
          this.loadingButton = false;     
          this.checkPrice(); 
        },
        error => {
          this.loadingButton = false;      
        }
      );      
    }


    
    
  }

  /**
   * Valid Info
   */
  validInfo(key) {
    switch (key) {
      case "email":
        this.validAccountHolder = true;
        this.dataForm[0].isInCart = true;

        break;

      case "address":
        var addresstext = <HTMLInputElement>(
          document.getElementById("addresstext0")
        );
        addresstext.disabled = true;

        break;

      default:
        break;
    }
  }

  /**
   * On Submit
   */
  onSubmit() {
    this.submitted = true;

    // stop here if form is invalid

    if (this.registerForm.status === "VALID") {
      this.questionBeforeOpen();
    }
  }

  /**
   * Question Before Open
   */
  questionBeforeOpen() {
    Swal.fire({
      icon: "info",
      title: "Checking Members",
      html: '<div><p>We are checking the eligibility of your new members</P></div><div class="spinner-grow text-primary" style="width: 3rem; height: 3rem" role="status"><span class="sr-only">Loading...</span></div>',
      allowOutsideClick: function () {
        return !Swal.isLoading();
      },
      showConfirmButton: false,
    });

    

    this.updateForm()
    .then((result: any) => {
      if (result == 'Approved') {
        if(this.iframe == true){
          window.parent.postMessage({ event: "lead_conversion" }, "*");
        }
        Swal.fire({
          title: "Approved!",
          text: "This Account Holder have been approved.",
          icon: "success",
          showConfirmButton: true,
          allowOutsideClick: function () {
            return !Swal.isLoading();
          },
        }).then(function () {
          var btn = document.getElementById("validEmail");
          btn?.click();
          var btn = document.getElementById("nextStep");
          btn?.click();
        });
      } else if (result == 'Updated') {
        Swal.close();
        var btn = document.getElementById("validEmail");
        btn?.click();
        var btn = document.getElementById("nextStep");
            btn?.click();           
      }
    });     
  }

  /**
   * Add Item
   */

  addDependent() {
    this.dataForm.push({
      firstName: "",
      lastName: "",
      email: "",
      countryAreaCode: 61,
      phoneNumber: "",
      gender: "",
      DoB: this.today,
      membership: "Dependent",
      address: this.registerForm.controls.address.value,
      plan_id: Number(this.dataForm[0].plan_id),
      planPrices:
        this.products[
          this.products.findIndex((p) => p.id === this.dataForm[0].plan_id)
        ].pricing,
      isInCart: false,
    });
  }

  isCartDone() {
    var result = false;
    if (this.dataForm.length > 0) {
      for (let index = 0; index < this.dataForm.length; index++) {
        const element = this.dataForm[index];        
        result = element.isInCart;
        if (element.isInCart == false) {
          result = false;
          return result;
        }
      }
    } else {
      result = true;
    }
    return result;

  }

  addToDependentCart(index) {
    this.products[index].dependentCartList = true;
  }

  // Public Methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * On Change Members Number
   */
  checkPrice() {
    this.totalPrice = { annually: 0, monthly: 0, weekly: 0, fortnightly: 0 };
    this.totalDiscount = { annually: 0, monthly: 0, weekly: 0, fortnightly: 0 };
    let locationSettings = this.info.location.settings;
    
    if (this.dependentCartList.length > 0 && this.dependentCartList.length >= locationSettings.dependent_discount.goal - 1 && locationSettings.dependent_discount.isActive) {
      this.discountList[0].valid = true;
      this.discountList[0].setup_amount = locationSettings.dependent_discount.setup_amount;
      this.discountList[0].setup_percentage = locationSettings.dependent_discount.setup_percentage;
      this.discountList[0].membership_amount = locationSettings.dependent_discount.membership_amount;
      this.discountList[0].membership_percentage = locationSettings.dependent_discount.membership_percentage;
    } else {
      this.discountList[0].valid = false;
    }

    this.priceCounter = {
      setupFee: {
        holder: 0,
        dependents: 0,
        holderDiscount: 0,
        dependentsDiscount: 0,
        discount: 0,
        smilepass: 0,
        total:0
      },
      membershipFee: {
        holder: { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 },
        holderDiscount: { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 },
        dependents: { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 },
        dependentsDiscount: { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 },
        discount: { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 },
        smilepass: { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 },
        total: { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 }
      }
      
    };

    if(this.dataForm[0].plan_id > 0){
      //holder setupFee
      this.priceCounter.setupFee.holder =
      this.products[
        this.products.findIndex((p) => p.id === Number(this.dataForm[0].plan_id))
      ].setupFee;
      //holder membershipFee
      this.priceCounter.membershipFee.holder =
      this.products[
        this.products.findIndex((p) => p.id === Number(this.dataForm[0].plan_id))
      ].pricing;
    }

    //dependent
    for (let index = 0; index < this.dataForm.length; index++) {
      const element = this.dataForm[index];

      if (index > 0 && element.isInCart) {
        //dependent setupFee
        this.priceCounter.setupFee.dependents = this.priceCounter.setupFee.dependents +
        this.products[
          this.products.findIndex((p) => p.id === Number(element.plan_id))
        ].setupFee;
    
        //dependent membershipFee
        this.priceCounter.membershipFee.dependents = { 
          annually: this.priceCounter.membershipFee.dependents.annually + this.products[
            this.products.findIndex((p) => p.id === Number(element.plan_id))
          ].pricing.annually, 
          monthly: this.priceCounter.membershipFee.dependents.monthly + this.products[
            this.products.findIndex((p) => p.id === Number(element.plan_id))
          ].pricing.monthly,  
          fortnightly: this.priceCounter.membershipFee.dependents.fortnightly + this.products[
            this.products.findIndex((p) => p.id === Number(element.plan_id))
          ].pricing.fortnightly,  
          weekly: this.priceCounter.membershipFee.dependents.weekly + this.products[
            this.products.findIndex((p) => p.id === Number(element.plan_id))
          ].pricing.weekly
        };
        this.products[
          this.products.findIndex((p) => p.id === Number(element.plan_id))
        ].pricing;
      }
    }
    
    //discount membership        
    this.priceCounter.membershipFee.discount = 
    { 
      annually: 0, 
      monthly: 0, 
      fortnightly: 0, 
      weekly: 0
    };

    //discount
    for (let index = 0; index < this.discountList.length; index++) {
      const element = this.discountList[index];

      //discount setupFee
      let validPlanDiscount = false;
      let checkedList = [];

      //iterate through list of plans related to the coupon and check if plan_id of member is comprised in the list, if it is the current list item is added to the list of valid items
      for(const listItem of this.dataForm) {
        validPlanDiscount = element.planList.findIndex((p) => p === listItem.plan_id) > -1;
        listItem['validPlanDiscount'] = validPlanDiscount;
        if(validPlanDiscount) {
          checkedList.push(listItem);
        }
      }

      //if coupon is valid and (the size of the checked list is different from dataForm this means one of the plans is not comprised by this coupon or there is no plan restriction usage - planList.length ==0)
      if (element.valid == true  && (checkedList.length == this.dataForm.length || element.planList.length == 0)) {
 
        this.priceCounter.setupFee.holderDiscount = element.setup_amount + (this.priceCounter.setupFee.holder * element.setup_percentage)/100;

        if(this.priceCounter.setupFee.dependents > 0) {
          this.priceCounter.setupFee.dependentsDiscount = (this.priceCounter.setupFee.dependents * element.setup_percentage)/100;
        }

        this.priceCounter.setupFee.discount +=
        (this.priceCounter.setupFee.holderDiscount + this.priceCounter.setupFee.dependentsDiscount);

        this.priceCounter.membershipFee.discount.annually += element.membership_amount + (
          (this.priceCounter.membershipFee.holder.annually 
            + 
          this.priceCounter.membershipFee.dependents.annually)
          *element.membership_percentage) / 100;
        this.priceCounter.membershipFee.discount.monthly += element.membership_amount + (
          (this.priceCounter.membershipFee.holder.monthly 
            + 
          this.priceCounter.membershipFee.dependents.monthly)
          *element.membership_percentage) / 100;
        this.priceCounter.membershipFee.discount.fortnightly += element.membership_amount + (
          (this.priceCounter.membershipFee.holder.fortnightly 
            + 
          this.priceCounter.membershipFee.dependents.fortnightly)
          *element.membership_percentage) / 100;
        this.priceCounter.membershipFee.discount.weekly += element.membership_amount + (
          (this.priceCounter.membershipFee.holder.weekly 
            + 
          this.priceCounter.membershipFee.dependents.weekly)
          *element.membership_percentage) / 100;

        this.priceCounter.membershipFee.holderDiscount = { 
          annually: (this.priceCounter.membershipFee.holder.annually*element.membership_percentage/100) + element.membership_amount/this.dataForm.length, 
          monthly: (this.priceCounter.membershipFee.holder.monthly*element.membership_percentage/100) + element.membership_amount/this.dataForm.length, 
          fortnightly: (this.priceCounter.membershipFee.holder.fortnightly*element.membership_percentage/100) + element.membership_amount/this.dataForm.length, 
          weekly: (this.priceCounter.membershipFee.holder.weekly*element.membership_percentage/100) + element.membership_amount/this.dataForm.length, 
        }

        this.priceCounter.membershipFee.dependentsDiscount = { 
          annually: (this.priceCounter.membershipFee.dependents.annually*element.membership_percentage/100) + element.membership_amount/this.dataForm.length, 
          monthly: (this.priceCounter.membershipFee.dependents.monthly*element.membership_percentage/100) + element.membership_amount/this.dataForm.length, 
          fortnightly: (this.priceCounter.membershipFee.dependents.fortnightly*element.membership_percentage/100) + element.membership_amount/this.dataForm.length, 
          weekly: (this.priceCounter.membershipFee.dependents.weekly*element.membership_percentage/100) + element.membership_amount/this.dataForm.length, 
        }
        
    }
    }

    this.priceCounter.setupFee.smilepass = 
        ((this.priceCounter.setupFee.holder + 
          this.priceCounter.setupFee.dependents - 
          this.priceCounter.setupFee.discount) *
          this.info.location.chargeFee.membership.extra.percentage / 100
      );

    this.priceCounter.setupFee.total = 
      this.priceCounter.setupFee.holder + 
      this.priceCounter.setupFee.dependents +
      this.priceCounter.setupFee.smilepass - 
      this.priceCounter.setupFee.discount;

      if(this.priceCounter.setupFee.total <= this.priceCounter.setupFee.smilepass){
        this.priceCounter.setupFee.total = 0;
        this.priceCounter.setupFee.smilepass = 0;
      }

      this.priceCounter.membershipFee.smilepass = 
      { 
        annually: 
          ((this.priceCounter.membershipFee.holder.annually 
            + 
          this.priceCounter.membershipFee.dependents.annually
            -
          this.priceCounter.membershipFee.discount.annually)
          *
          this.info.location.chargeFee.membership.extra.percentage / 100
          )+ this.info.location.chargeFee.membership.extra.amount, 
        monthly: 
          ((this.priceCounter.membershipFee.holder.monthly 
            + 
          this.priceCounter.membershipFee.dependents.monthly
            -
          this.priceCounter.membershipFee.discount.monthly)
          *
          this.info.location.chargeFee.membership.extra.percentage / 100
          )+ this.info.location.chargeFee.membership.extra.amount, 
        fortnightly: 
          ((this.priceCounter.membershipFee.holder.fortnightly 
            + 
          this.priceCounter.membershipFee.dependents.fortnightly
            -
          this.priceCounter.membershipFee.discount.fortnightly)
          *
          this.info.location.chargeFee.membership.extra.percentage / 100
          )+ this.info.location.chargeFee.membership.extra.amount,
        weekly:         
          ((this.priceCounter.membershipFee.holder.weekly 
            + 
          this.priceCounter.membershipFee.dependents.weekly
            -
          this.priceCounter.membershipFee.discount.weekly)
          *
          this.info.location.chargeFee.membership.extra.percentage / 100
          )+ this.info.location.chargeFee.membership.extra.amount
      };

        this.priceCounter.membershipFee.total = 
        { 
          annually: 
            (this.priceCounter.membershipFee.holder.annually 
              + 
            this.priceCounter.membershipFee.dependents.annually
              -
            this.priceCounter.membershipFee.discount.annually
              +
              this.priceCounter.membershipFee.smilepass.annually
            ), 
          monthly: 
            (this.priceCounter.membershipFee.holder.monthly 
              + 
            this.priceCounter.membershipFee.dependents.monthly
              -
            this.priceCounter.membershipFee.discount.monthly
            +
            this.priceCounter.membershipFee.smilepass.monthly
            ), 
          fortnightly: 
            (this.priceCounter.membershipFee.holder.fortnightly 
              + 
            this.priceCounter.membershipFee.dependents.fortnightly
              -
            this.priceCounter.membershipFee.discount.fortnightly
            +
            this.priceCounter.membershipFee.smilepass.fortnightly
            ), 
          weekly:         
            (this.priceCounter.membershipFee.holder.weekly 
              + 
            this.priceCounter.membershipFee.dependents.weekly
              -
            this.priceCounter.membershipFee.discount.weekly
            +
            this.priceCounter.membershipFee.smilepass.weekly
            )
        };

        if(this.priceCounter.membershipFee.total.annually <= this.priceCounter.membershipFee.smilepass.annually){
          this.priceCounter.membershipFee.total.annually = 0;
          this.priceCounter.membershipFee.smilepass.annually = 0;

        };
        if(this.priceCounter.membershipFee.total.monthly <= this.priceCounter.membershipFee.smilepass.monthly){
          this.priceCounter.membershipFee.total.monthly = 0;
          this.priceCounter.membershipFee.smilepass.monthly = 0;

        };
        if(this.priceCounter.membershipFee.total.fortnightly <= this.priceCounter.membershipFee.smilepass.fortnightly){
          this.priceCounter.membershipFee.total.fortnightly = 0;
          this.priceCounter.membershipFee.smilepass.fortnightly = 0;

        };
        if(this.priceCounter.membershipFee.total.weekly <= this.priceCounter.membershipFee.smilepass.weekly){
          this.priceCounter.membershipFee.total.weekly = 0;
          this.priceCounter.membershipFee.smilepass.weekly = 0;

        };

    this.totalPrice = { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 };
    this.totalDiscount = { annually: 0, monthly: 0, fortnightly: 0, weekly: 0 };


    for (let index = 0; index < this.products.length; index++) {
      const element = this.products[index];

      this.totalPrice.annually += element.qtyInCart * element.pricing.annually;
      this.totalPrice.monthly += element.qtyInCart * element.pricing.monthly;
      this.totalPrice.fortnightly +=
        element.qtyInCart * element.pricing.fortnightly;
      this.totalPrice.weekly += element.qtyInCart * element.pricing.weekly;

      this.totalPrice.annually +=
        element.qtyInDependentCart * element.pricing.annually;
      this.totalPrice.monthly +=
        element.qtyInDependentCart * element.pricing.monthly;
      this.totalPrice.fortnightly +=
        element.qtyInDependentCart * element.pricing.fortnightly;
      this.totalPrice.weekly +=
        element.qtyInDependentCart * element.pricing.weekly;
    }

    for (let index = 0; index < this.discountList.length; index++) {
      const element = this.discountList[index];
      if (element.valid == true) {
        element["couponSetupDiscount"] = (((this.priceCounter.setupFee.dependents + this.priceCounter.setupFee.holder)*element.setup_percentage)/100) + element.setup_amount;

        element["couponMembershipDiscount"] = {
          annually: (((this.priceCounter.membershipFee.dependents.annually + this.priceCounter.membershipFee.holder.annually)*element.membership_percentage)/100) + element.membership_amount,

          monthly: (((this.priceCounter.membershipFee.dependents.monthly + this.priceCounter.membershipFee.holder.monthly)*element.membership_percentage)/100) + element.membership_amount,

          fortnightly: (((this.priceCounter.membershipFee.dependents.fortnightly + this.priceCounter.membershipFee.holder.fortnightly)*element.membership_percentage)/100) + element.membership_amount,

          weekly: (((this.priceCounter.membershipFee.dependents.weekly + this.priceCounter.membershipFee.holder.weekly)*element.membership_percentage)/100) + element.membership_amount
        }

        element["couponDiscount"] = {
          annually: (((this.priceCounter.membershipFee.dependents.annually + this.priceCounter.membershipFee.holder.annually)*element.membership_percentage)/100) + element.membership_amount 
          + (((this.priceCounter.setupFee.dependents + this.priceCounter.setupFee.holder)*element.setup_percentage)/100) + element.setup_amount,
          
          monthly: (((this.priceCounter.membershipFee.dependents.monthly + this.priceCounter.membershipFee.holder.monthly)*element.membership_percentage)/100) + element.membership_amount 
          + (((this.priceCounter.setupFee.dependents + this.priceCounter.setupFee.holder)*element.setup_percentage)/100) + element.setup_amount,
          
          fortnightly: (((this.priceCounter.membershipFee.dependents.fortnightly + this.priceCounter.membershipFee.holder.fortnightly)*element.membership_percentage)/100) + element.membership_amount 
          + (((this.priceCounter.setupFee.dependents + this.priceCounter.setupFee.holder)*element.setup_percentage)/100) + element.setup_amount,
          
          weekly: (((this.priceCounter.membershipFee.dependents.weekly + this.priceCounter.membershipFee.holder.weekly)*element.membership_percentage)/100) + element.membership_amount 
          + (((this.priceCounter.setupFee.dependents + this.priceCounter.setupFee.holder)*element.setup_percentage)/100) + element.setup_amount,
        };

        element["totalDiscount"] = {
          annually: 0,
          monthly: 0,
          fortnightly: 0,
          weekly: 0
        };

        element.totalDiscount.annually += element.couponDiscount.annually
        element.totalDiscount.monthly += element.couponDiscount.monthly
        element.totalDiscount.fortnightly += element.couponDiscount.fortnightly
        element.totalDiscount.weekly += element.couponDiscount.weekly
      
        this.totalDiscount.annually += element["totalDiscount"].annually;
        this.totalDiscount.monthly += element["totalDiscount"].monthly;
        this.totalDiscount.fortnightly += element["totalDiscount"].fortnightly;
        this.totalDiscount.weekly += element["totalDiscount"].weekly;

        element.totalDiscount = this.totalDiscount;
      }
    }  
  }

  setPrice(index, plan_id) {
    this.dataForm[index].planPrices =
      this.products[
        this.products.findIndex((p) => p.id === Number(plan_id))
      ].pricing;
  }

  selectProduct(product_id) {
    this.cartList = [{ id: 0, productId: product_id, qty: 1 }];
    if (product_id != this.dataForm[0].plan_id) {
      this.dataForm[0].plan_id = Number(product_id);

      this.products.forEach((product) => {
        var index = this.cartList.findIndex((p) => p.productId === product.id);
        product.isInCart = index > -1;
        if (index > -1) {
          product.qtyInCart = this.cartList[index].qty;
        } else {
          product.qtyInCart = 0;
        }
        // product.qtyInDependentCart = 0;
      });
    }
    this.checkPrice();
    this.updateForm().then(function (result: any) {
      if(result == "Updated"){  
        var btn = document.getElementById("nextStep");
        btn?.click();
      }

    });
  }

  selectDependentProduct(index) {
    var plan_id = Number(this.dataForm[index].plan_id);
    this.dataForm[index].isInCart = true;
    this.dataForm[index].plan_id = plan_id;

    var productsId = this.products.findIndex((p) => p.id === plan_id);
    var cartId = this.dependentCartList.findIndex(
      (p) => p.productId === plan_id
    );
    this.products[productsId].isInDependentCartList = true;

    if (cartId === -1) {
      const maxValueId =
        Math.max(...this.dependentCartList.map((cart) => cart.id), 0) + 1;
      this.dependentCartList.push({
        id: maxValueId,
        productId: plan_id,
        qty: 1,
      });
    } else {
      this.dependentCartList[cartId].qty += 1;
    }
    cartId = this.dependentCartList.findIndex((p) => p.productId === plan_id);

    this.products[productsId].qtyInDependentCart =
      this.dependentCartList[cartId].qty;

    this.checkPrice();
    this.updateForm();

  }

  unselectDependentProduct(index) {
    var plan_id = Number(this.dataForm[index].plan_id);

    this.dataForm[index].isInCart = false;

    var productsId = this.products.findIndex((p) => p.id === plan_id);
    var cartId = this.dependentCartList.findIndex(
      (p) => p.productId === plan_id
    );

    if (this.dependentCartList[cartId].qty > 1) {
      this.dependentCartList[cartId].qty -= 1;
      this.products[productsId].qtyInDependentCart =
        this.dependentCartList[cartId].qty;
    } else {
      this.dependentCartList.splice(cartId, 1);
      this.products[productsId].isInDependentCartList = false;
      this.products[productsId].qtyInDependentCart = 0;
    }

    this.checkPrice();
  }

  currentPlanTitle(plan_id) {
    let currentProduct = this.products.find((product) => product.id == plan_id);

    return currentProduct;
  }

  /**
   * Stepper Next
   */
  nextStep() {
    this.checkoutStepper.next();
  }
  /**
   * Stepper Previous
   */
  previousStep() {
    this.checkoutStepper.previous();
  }

  formatPhoneNumber(phone) {
    // Remove any leading 0
    if (phone.startsWith("0")) {
        phone = phone.substring(1);
    }
    // Format as XXX XXX XXX
    return phone.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3");
}

  btnToSendForm(){
    this._communicationService
    .sendOrder(this.token)
      .then((response) => {

        if(this.iframe == true){
          // Send a sale event when the user click submit
            let saleValue = this.info.contractTotal || 1; 
            let saleCurrency = this.info.location.locationCurrency || "AUD";
            window.parent.postMessage({ 
                event: "sale_conversion",
                value: parseFloat(saleValue),  // Ensure it's a valid number
                currency: saleCurrency 
            }, "*");


        }

        let type: string = "new";
        let data: any;
        data = response;
        if (data.activeMethod) {
          Swal.fire({
            title: "Proceed to Checkout",
            html:
              "<div><p>Use your registered payment method to complete the transaction?</p></div><div><small>Payment Method: " +
              data.methodInfo.type +
              "</small><br><small>Last four digits: " +
              data.methodInfo.last4 +
              "</small></div>",
            text: "Payment Method",
            
            showCancelButton: true,
            confirmButtonText: "Use Current Payment Method",
            cancelButtonText: "Add New Payment Method",
            customClass: {
              confirmButton: "btn btn-success",
              cancelButton: "btn btn-primary",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              type = "primary";
              this.loadingButton = true;
              this._communicationService.usePaymentMethod(this.token, type).then((response:any) => {
                
                if(response[0] != 'No valid payment method was found for this payment, please register a new method and try again.' ){
                  location.reload();
                }else{
                  Swal.fire({
                    title: "Failed",
                    html:
                      '<div><p>No valid payment method was found for this payment, please register a new method and try again.</p></div>',
                    icon: "error",
                    customClass: {
                      confirmButton: "btn btn-success",
                    },
                  }).then(() => {
                    this.loadingButton = false;
                  });
                }
                
              });

            } else if (result.dismiss === Swal.DismissReason.cancel) {
              this._communicationService.usePaymentMethod(this.token, type);
              if(this.iframe == true){
                this.loading = true;
                window.open(data.url, "_blank");
                this.info.status = 'sent2payment';
                Swal.fire({
                  title: "Waiting Payment",
                  html:
                    `<div><p>You will be redirected to a page to complete the payment. If it doesn't open, click <a href= "${
                  data.url }
                    " target="_blank">here</a>!</p></div>`,
                  icon: "success",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then((result: any) => {
                  this.loading = false;
                });
              }else{
                window.open(data.url, "_self");
              };
            }
          });
        } else {
          if(this.iframe == true){
            this.loading = true;
            window.open(data.url, "_blank");
            this.info.status = 'sent2payment';
            Swal.fire({
              title: "Waiting Payment",
              html:
                `<div><p>You will be redirected to complete the payment. If it doesn't open, click <a href= "${
                  data.url }
                " target="_blank">here</a>!</p></div>`,
              icon: "success",
              customClass: {
                confirmButton: "btn btn-success",
              },
            }).then((result: any) => {
              this.loading = false;
            });

          }else{
            window.open(data.url, "_self");
          };
          this._communicationService.usePaymentMethod(this.token, type);
        }
      })
      .catch((error) => {
        console.error("Error with PATCH request", error);
      });
  }

  /**
   * On sendForm
   */
  sendForm() {

    this.updateForm().then(function (result: any) {      
      if(result == "Updated"){  

        var btn = document.getElementById("btnToSendForm");
          btn?.click();


      }else{
        Swal.fire({
          title: "Cancelled",
          text: "Error with request.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-success",
          },
        });
      }

    });

  };

    /**
   * On sendForm
   */
    updateForm() {
      return new Promise((resolve, reject) => {

        var firstName = <HTMLInputElement>document.getElementById("firstName0");
        var lastName = <HTMLInputElement>document.getElementById("lastName0");
        var gender = <HTMLInputElement>document.getElementById("gender0");
        var DoB = <HTMLInputElement>document.getElementById("DoB0");
        var address = <HTMLInputElement>document.getElementById("addresstext0");
        var email = <HTMLInputElement>document.getElementById("email0");
        var phoneNumber = <HTMLInputElement>document.getElementById("phoneNumber0");
    
        this.dataForm[0].firstName = firstName?.value;
        this.dataForm[0].lastName = lastName?.value;
        this.dataForm[0].gender = gender?.value;
        this.dataForm[0].DoB = DoB?.value;
        this.dataForm[0].membership = "Holder";
        this.dataForm[0].address = address?.value;
        this.dataForm[0].email = email?.value;
        this.dataForm[0].countryAreaCode = 61;
        this.dataForm[0].phoneNumber = phoneNumber?.value.replace(/\D+/g, "");
  
        for (let index = 0; index < this.dataPlanOrder.length; index++) {
          const element = this.dataPlanOrder[index];
          this.dataForm[index]["productId"] = element.id;
        }
    
        var order = {
          startDate: this.startAtDate,
          planDetails: this.dataForm,
          contractCycle: this.paymentPer,
          returnLink: String(window.location.href),
        };
        
        this._communicationService
          .updateOrder(this.token, order)
          .then(function (result: any) {
            resolve(result);
            if(result.statement == "Throw Error"){
              Swal.fire({
                title: "Failed",
                text: result.payload,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            }
            
            
          }) 
          .catch((error) => {
            reject(error);
            console.error(error);
            });
      });

    };

  selectTerm(index) {
    this.currentTermIdx = index;

    switch (index) {
      case 0:
        this.currentTerm = {
          title: this.info.terms_of_use.title,
          content: this.info.terms_of_use.content,
        };
        var term = <HTMLInputElement>(
          document.getElementById("term")
        );

        term.innerHTML = this.info.terms_of_use.content;
  

        break;

      default:
        var treatment = "";
        this.currentPlanTitle(this.dataForm[index-1].plan_id).treatment.forEach(element => {
          var procedures = ""
          var annualQuantity = 'Unlimited';
          if(element.annualQuantity > 0){
            annualQuantity = element.annualQuantity;
          }
          element.procedures.forEach(procedure => {
            var procedures = procedures + `<li>${procedure.name}</li>`;
          });
          treatment = treatment + `
          
          <li> ${element.title} </li>
          <ul>
          <li><strong>Annual quantity:</strong> ${annualQuantity}</li>
          <li><strong>Waiting period (months):</strong> ${element.waitingPeriod}</li>
          <li><strong>Procedures included:</strong>
          <ul>
          ${procedures}
          </ul>
          </li>
          <li><strong>Additional Notes:</strong> ${element.specificTermsConditions}</li>
          </ul>          
          `;
        });

        var discount = "";
        this.currentPlanTitle(this.dataForm[index-1].plan_id).servicesProductsDiscounts.forEach(element => {
          discount = discount + `
          <li>${element.name} - ${element.discount}% (${element.terms});</li>
          `;
        });

        var generalTerms = "";
        this.currentPlanTitle(this.dataForm[index-1].plan_id).generalTerms.forEach(element => {
          generalTerms = generalTerms + `
          <li><strong>${element.title}:</strong> ${element.content};</li>
          `;
        });

        let ageRangeText: any;

        if(this.currentPlanTitle(this.dataForm[index-1].plan_id).ageFrom === this.currentPlanTitle(this.dataForm[index-1].plan_id).ageTo && this.currentPlanTitle(this.dataForm[index-1].plan_id).ageFrom === 0) {
          ageRangeText = `there are no age restrictions for this plan` 
        } else {
          ageRangeText = `this plan is available only to individuals aged from ${this.currentPlanTitle(this.dataForm[index-1].plan_id).ageFrom} to ${this.currentPlanTitle(this.dataForm[index-1].plan_id).ageTo} years.` 
        }
        
        var text = 
          `
          <p><strong>Member name: ${this.dataForm[index-1].firstName + " " + this.dataForm[index-1].lastName}</strong></p>
          <ul>
          <li><strong>Plan Name:</strong> ${this.currentPlanTitle(this.dataForm[index-1].plan_id).title}</li>
          <li><strong>Plan Description:</strong> ${this.currentPlanTitle(this.dataForm[index-1].plan_id).description}</li>
          <li><strong>Membership Fee</strong>:</li>
          <ul>
          <li><strong>Setup Fee:</strong> $${this.currentPlanTitle(this.dataForm[index-1].plan_id).setupFee.toFixed(2)}</li>
          <li><strong>Fee Amount:</strong> $${this.currentPlanTitle(this.dataForm[index-1].plan_id).pricing[this.paymentPer].toFixed(2)}</li>
          <li><strong>Payment Schedule:</strong> ${ this.paymentPer }</li>
          </ul>
          <li><strong>Included Services and benefits:</strong>&nbsp;</li>
          <ul>
          ${treatment}
          </ul>
          <li><strong>Discounts on Services and Products:</strong>
          <ul>
          ${discount}
          </ul>
          </li>
          <li><strong>Terms:&nbsp;</strong>
          <ul>
          <li><strong>Membership lock-in period (months)</strong>: ${this.currentPlanTitle(this.dataForm[index-1].plan_id).minPeriod}</li>
          <li><strong>Age range limitation</strong>: ${ageRangeText}.&nbsp;</li>
          ${generalTerms}
          </ul>
          </li>
          </ul>`;

        // this.data.membership.planTerms[this.currentTermIdx].content.split(
        //   "{firstName}"
        // );
        // var newText = "";

        // for (let index = 0; index < text.length; index++) {
        //   const element = text[index];
        //   newText += element;
        //   if (index + 1 != text.length) {
        //     newText += this.data.firstName;
        //   }
        // }

        //Add firstName
        // text = newText.split("{lastName}");
        // var newText = "";

        // for (let index = 0; index < text.length; index++) {
        //   const element = text[index];
        //   newText += element;
        //   if (index + 1 != text.length) {
        //     newText += this.data.lastName;
        //   }
        // }

        var term = <HTMLInputElement>(
          document.getElementById("term")
        );
        term.innerHTML = text;
  

        this.currentTerm = {
          title: "Membership Plan Specific Terms and Conditions",
          content: text
        };


        break;
    }

  }

  confirmTermInput(){
    this.termCheck = true;   
    this.modalService.dismissAll();    
  };

  checkTermInput(){
    this.termCheck = !this.termCheck;   
  };

    // modal Open Large
    modalOpen(modalLG, size) {

      this.modalService.open(modalLG, {
        centered: true,
        size: size,
      });
      this.selectTerm(0);
    };

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.loading = true;
    // get return url from route parameters or default to '/'
    this.token = this._route.snapshot.queryParams["token"] || "/";
    // get return url from route parameters or default to '/'
    this.iframe = Boolean(this._route.snapshot.queryParams["iframe"]) || false;
    this._communicationService
      .getReferralByToken(this.token)
      .pipe(first())
      .subscribe(
        (data) => {
          this.info = data;
          this.startAtDate = this.info.startDate;
          switch (this.info.status) {
            case "done":
              this.loading = false;
              Swal.fire({
                title: "Congratulations!",
                html:
                  '<div><p>You are a SmilePass member.</p></div> <div><p>Book your next <a href="' +
                  this.info.location.locationWebsite +
                  '">appointment</a> now!</p></div>',
                text: "You and your dependents are now SmilePass members.",
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              }).then(function () {});
              break;
            case "open":
            case "sent":
            case  "pay":
              this.paymentPer = this.info.contractCycle;
              this.totalPrice = {
                annually: 0,
                monthly: 0,
                fortnightly: 0,
                weekly: 0,
              };
              this.loading = false;
              this.dataForm = [];
              this.info.planDetails.forEach((element) => {
                this.dataForm.push({
                  firstName: element.firstName,
                  lastName: element.lastName,
                  email: element.email,
                  countryAreaCode: element.countryAreaCode,
                  phoneNumber: element.phoneNumber,
                  gender: element.gender,
                  DoB: element.DoB,
                  membership: element.membership,
                  address: element.address,
                  plan_id: element.plan_id,
                  planPrice: element.planPrice,
                  setupFee: element.setupFee,
                  isInCart: (element.plan_id > 0),
                });
              });              
              this.registerForm = this._formBuilder.group({
                id: [this.dataForm[0].id],
                firstName: [this.dataForm[0].firstName, [Validators.required]],
                lastName: [this.dataForm[0].lastName, [Validators.required]],
                email: [
                  this.dataForm[0].email,
                  [Validators.required, Validators.email],
                ],
                countryAreaCode: [
                  this.dataForm[0].countryAreaCode,
                  [Validators.required],
                ],
                phoneNumber: [
                  this.dataForm[0].phoneNumber,
                  [Validators.required],
                ],
                gender: [this.dataForm[0].gender, [Validators.required]],
                DoB: [this.dataForm[0].DoB, [Validators.required]],
                address: [this.dataForm[0].address, [Validators.required]],
              });
              setTimeout(() => {
                var checkoutStepperElement: any =
                  document.querySelector("#checkoutStepper");
                this.checkoutStepper = new Stepper(checkoutStepperElement, {
                  linear: false,
                  animation: true,
                });
                if(this.info.planDetails[0].plan_id){
                  this.cartList = [
                    {
                      id: 0,
                      productId: this.info.planDetails[0].plan_id,
                      qty: 1,
                    },
                  ];
                };
                this.products = this.info.plans;

                this.products.forEach((product) => {
                  product.isInWishlist = false;
                  var index = this.cartList.findIndex(
                    (p) => p.productId === product.id
                  );
                  product.isInCart = index > -1;
                  if (index > -1) {
                    product.qtyInCart = this.cartList[index].qty;
                  } else {
                    product.qtyInCart = 0;
                  }
                  product.qtyInDependentCart = 0;
                });

                for (
                  let index = 1;
                  index < this.info.planDetails.length;
                  index++
                ) {
                  const element = this.info.planDetails[index];
                  var productsId = this.products.findIndex(
                    (p) => p.id === element.plan_id
                  );
                  var cartId = this.dependentCartList.findIndex(
                    (p) => p.productId === element.plan_id
                  );
                  this.products[productsId].isInDependentCartList = true;
                  this.dataForm[index]["planPrices"] =
                    this.products[
                      this.products.findIndex((p) => p.id === element.plan_id)
                    ].pricing;

                  if (cartId === -1) {
                    const maxValueId =
                      Math.max(
                        ...this.dependentCartList.map((cart) => cart.id),
                        0
                      ) + 1;
                    this.dependentCartList.push({
                      id: maxValueId,
                      productId: element.plan_id,
                      qty: 1,
                    });
                  } else {
                    this.dependentCartList[cartId].qty += 1;
                  }
                  cartId = this.dependentCartList.findIndex(
                    (p) => p.productId === element.plan_id
                  );

                  this.products[productsId].qtyInDependentCart =
                    this.dependentCartList[cartId].qty;
                }
                this.products.forEach((product) => {
                  product.isInWishlist = false;
                  product.isInCart =
                    this.cartList.findIndex((p) => p.productId === product.id) >
                    -1;
                });
                if (this.info.status == "pay") {
                  var checkoutStepperElement: any =
                    document.querySelector("#checkoutStepper");
                  this.checkoutStepper = new Stepper(checkoutStepperElement, {
                    linear: false,
                    animation: true,
                  });
                  this.validAccountHolder = true;
                  this.checkoutStepper.to(4);
                }

                var code = <HTMLInputElement>(
                  document.getElementById("couponCode")
                );
                code.value = this.info.couponCode;
                if(code.value.length > 0 ){
                  this.checkCoupon();
                }

                this.checkPrice();
                this.checkStep();


              }, 1);
              break;

              default:
              this.loading = false;

              break;
          }
        },
        (error) => {
          this.loading = false;
        }
      );

    // Subscribe to config changes
    this._coreConfigService.config
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((config) => {
        this.coreConfig = config;
      });
  }

  checkStep(){
    var hasHolderPlan = this.dataForm[0].isInCart;
    var hasHolder = (this.dataForm[0].firstName != "");
    var hasDependent = (this.dataForm.length > 1);
    var inCartCounter = 0; 

    this.dataForm.forEach(element => {
      if(element.isInCart == true){        
        inCartCounter += 1;
      }
    });

    if(!hasHolderPlan){
      this.checkoutStepper.to(1);
    }else if(!hasHolder){
      this.checkoutStepper.to(2);
    }else if(!hasDependent){
      this.checkoutStepper.to(3);
    }else if(this.dataForm.length == inCartCounter){
      this.checkoutStepper.to(4);
    }

    
  };

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }
}
